// Produktbild fliegt beim Hinzufuegen in den Warenkorb.
//
// Dominik am 18.08.2026 (CRM #12): "auch kann ich bei nude mit one clicki n den
// Warenkorb geben". In der Antwort damals wurde ihm zugesagt, das Bild fliegt ins
// Warenkorbsymbol. Gebaut war es nie (siehe docs/pakete/V7-feedback-kontrollliste.md),
// das wird hier nachgeholt.
//
// Bewusst ohne Eingriff in Dawns Warenkorb-Logik: der Effekt haengt nur am Klick,
// klont das Bild und animiert den Klon. Schlaegt irgendein Schritt fehl, passiert
// einfach nichts, der Kauf laeuft in jedem Fall normal weiter.
(function () {
  'use strict'

  var reduziert = window.matchMedia('(prefers-reduced-motion: reduce)')
  var laeuft = 0

  function ziel() {
    return document.getElementById('cart-icon-bubble')
  }

  function bildZu(knopf) {
    // Erst innerhalb der Produktkarte oder des Produktformulars suchen, damit bei
    // mehreren Produkten auf der Seite das richtige Bild fliegt.
    var behaelter = knopf.closest('.sp-karte, .sp-kat, product-form, .sweet-po, form, li, article')
    var kandidat = behaelter && behaelter.querySelector('img')
    if (kandidat) return kandidat
    return document.querySelector('.sweet-po img, .product__media img')
  }

  function flieg(bild) {
    var korb = ziel()
    if (!bild || !korb || laeuft > 2) return
    var von = bild.getBoundingClientRect()
    var nach = korb.getBoundingClientRect()
    if (!von.width || !nach.width) return

    var klon = document.createElement('img')
    klon.src = bild.currentSrc || bild.src
    klon.alt = ''
    klon.setAttribute('aria-hidden', 'true')
    klon.style.cssText = [
      'position:fixed',
      'left:' + von.left + 'px',
      'top:' + von.top + 'px',
      'width:' + von.width + 'px',
      'height:' + von.height + 'px',
      'object-fit:cover',
      'border-radius:10px',
      'z-index:1000',
      'pointer-events:none',
      'transition:transform .62s cubic-bezier(.4,.05,.3,1),opacity .62s ease-in',
      'will-change:transform,opacity'
    ].join(';')
    document.body.appendChild(klon)
    laeuft++

    var dx = nach.left + nach.width / 2 - (von.left + von.width / 2)
    var dy = nach.top + nach.height / 2 - (von.top + von.height / 2)
    var faktor = Math.max(0.08, Math.min(0.3, nach.width / von.width))

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        klon.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + faktor + ')'
        klon.style.opacity = '0.25'
      })
    })

    var weg = function () {
      if (!klon.parentNode) return
      klon.remove()
      laeuft--
      korb.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.22)' }, { transform: 'scale(1)' }],
        { duration: 260, easing: 'ease-out' }
      )
    }
    klon.addEventListener('transitionend', weg, { once: true })
    setTimeout(weg, 900)
  }

  document.addEventListener(
    'click',
    function (e) {
      if (reduziert.matches) return
      var knopf = e.target.closest(
        'button[name="add"], .quick-add__submit, [data-sweet-sofortkauf], .sp-karte__kauf'
      )
      if (!knopf || knopf.disabled) return
      flieg(bildZu(knopf))
    },
    true
  )
})()
